import axios from 'axios'
// import NProgress from "./progress";
import { showFailToast, showToast } from "vant";

import router from '../router'
import { getToken } from "./auth";
import { pinia } from '@/store'

const userStore = useUserStore(pinia);


const CODE_MESSAGE = {
  200: '服务器成功返回请求数据',
  201: '新建或修改数据成功',
  202: '一个请求已经进入后台排队(异步任务)',
  204: '删除数据成功',
  400: '发出信息有误',
  401: '用户没有权限(令牌失效、用户名、密码错误、登录过期)',
  402: '令牌过期',
  403: '用户得到授权，但是访问是被禁止的',
  404: '访问资源不存在',
  406: '请求格式不可得',
  410: '请求资源被永久删除，且不会被看到',
  500: '服务器发生错误',
  502: '网关错误',
  503: '服务不可用，服务器暂时过载或维护',
  504: '网关超时',
}

/**
 * axios请求拦截器配置
 * @param config
 * @returns {any}
 */
const requestConf = (config) => {
  // NProgress.start();
  // 发送请求前，可在此携带 token
  const token = getToken()
  if (token) {
    config.headers['token'] = token
  }
  // FormData数据去请求头Content-Type
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
}
/**
 * axios响应拦截器
 * @param config 请求配置
 * @param data response数据
 * @param status HTTP status
 * @param statusText HTTP status text
 * @returns {Promise<*|*>}
 */
 const handleData = async ({ config, data, status, statusText }) => {
  // NProgress.done();
  // let code = status || 200

  let code = data && data['code'] ? data['code'] : status
  switch (code) {
    case 200:
      // 业务层级错误处理，以下是假定restful有一套统一输出格式(指不管成功与否都有相应的数据格式)情况下进行处理
      // 例如响应内容：
      // 错误内容：{ code: 1, msg: '非法参数' }
      // 正确内容：{ code: 200, data: {  }, msg: '操作正常' }
      // return data
      return data
    case 401:
      userStore.logout()
      router.push('/login')
      break
    case 402:
      return ''
    case 403:
      router.push({ path: '/403' }).then(() => { })
      break
  }
  // 异常处理
  const messageName = 'message'
  // 若data.msg存在，覆盖默认提醒消息
  const errMsg = `${data && data[messageName] ? data[messageName] : CODE_MESSAGE[code] ? CODE_MESSAGE[code] : statusText}`
  showFailToast(errMsg)
  return Promise.reject(data)
}

// 默认 axios 实例请求配置
const defaultConfig = {
  headers: {
    "Content-Type": 'application/json;charset=utf-8'
  },
  // 超时
  timeout: 50000,
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: import.meta.env.VITE_BASE_API,
  data: {}
};

// 创建axios实例
const service = axios.create(defaultConfig);
/**
 * @description axios请求拦截
 */
service.interceptors.request.use(requestConf, (error) => {
  return Promise.reject(error);
}
);
/**
 * @description axios响应拦截器
 */
service.interceptors.response.use(
  (response) => handleData(response),
  (error) => {
    // console.error('err' + error)
    const { response } = error
    if (response === undefined) {
      showToast('连接后台接口失败，可能由以下原因造成：后端不支持跨域CORS、接口地址不存在、请求超时等，请联系管理员排查后端接口问题 ')
      return {}
    } else {
      return handleData(response)
    }

  }
);


export default service
